import { getReturnedItems } from '../../../selectors/tools';
import { addEdgeToDecisionTreePath } from '../../searchActions';
import { RETURN_REFUND_STATUS_TOKENS } from '../../../constants/decisionTree';
import { formatTrackingNumber } from '../../../util';
import { getReturnShipmentCarrier, getReturnShipmentTrackingNumber } from '../../../extractFromState';
import { setLoading } from '../../index';
import { getShippoInfo } from '../../../api/orders/shippo';

export const loadShippingInformationForReturns = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const returnShipmentTrackingNumber = getReturnShipmentTrackingNumber(state);
    const trackingNumber = formatTrackingNumber(returnShipmentTrackingNumber);
    const returnedItems = getReturnedItems(state);

    const returnShipmentCarrier = getReturnShipmentCarrier(state);
    if (returnShipmentCarrier === 'carrier_not_found') {
      return dispatch(addEdgeToDecisionTreePath(RETURN_REFUND_STATUS_TOKENS.UNRECOGNIZED_CARRIER));
    }

    try {
      dispatch(setLoading(true, 'searchPage'));
      const shippoInfo = await getShippoInfo(returnShipmentCarrier, trackingNumber);
      if (shippoInfo.tracking_status) {
        if (['PRE_TRANSIT', 'FAILURE', 'UNKNOWN'].includes(shippoInfo.tracking_status)) {
          return dispatch(addEdgeToDecisionTreePath(RETURN_REFUND_STATUS_TOKENS.INVALID_STATUS));
        }
        if (returnedItems.length < 4 || shippoInfo.tracking_status === 'DELIVERED') {
          return dispatch(addEdgeToDecisionTreePath(RETURN_REFUND_STATUS_TOKENS.ITEM_HAS_BEEN_RETURNED));
        }

        return dispatch(addEdgeToDecisionTreePath(RETURN_REFUND_STATUS_TOKENS.FOUR_OR_MORE_UNRETURNED));
      }

      return dispatch(addEdgeToDecisionTreePath(RETURN_REFUND_STATUS_TOKENS.TRACKING_LINK_FAILED));
    } catch (error) {
      return dispatch(addEdgeToDecisionTreePath(RETURN_REFUND_STATUS_TOKENS.TRACKING_LINK_FAILED));
    } finally {
      dispatch(setLoading(false, 'searchPage'));
    }
  };
};
